import { render, staticRenderFns } from "./noticeRegistration.vue?vue&type=template&id=3b1a5967&scoped=true"
import script from "./noticeRegistration.vue?vue&type=script&lang=js"
export * from "./noticeRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1a5967",
  null
  
)

export default component.exports